export default "__VITE_ASSET__6ac3d30b__"